export default "__VITE_ASSET__l2kv$8t$__"